import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ConsultarLocalidadeRequest, Types } from './types';

// ACTIONS
import {
	consultarLocalidadeSuccess,
	consultarLocalidadeFailure,
} from './actions';

function* consultarLocalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarLocalidadeRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`localidades/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(consultarLocalidadeSuccess({ response, type: payload.type }));
	} else {
		yield put(consultarLocalidadeFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_LOCALIDADE_REQUEST, consultarLocalidade),
]);
